
import informes from '@/components/informes/informes'

const defaultMeta = {
  requiresAuth: false
}

const routes = [
  {
    path: '/informes',
    component: informes,
    name: 'informes'
  }
].map(r => {
  return {
    ...r,
    meta: Object.assign({}, defaultMeta, r.meta)
  }
})

export default routes
